import React from "react";
import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import { darken } from "polished";
import { arrayOf, bool, func, node, oneOfType, string } from "prop-types";
import { uncontrollable } from "uncontrollable";

const ExpandableContentWrapper = styled.a`
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  box-sizing: border-box;
  color: ${colors.classicBlue};
  cursor: pointer;
  display: inline-block;
  font: 700 11px/14px "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  text-transform: uppercase;
  user-select: none;

  &:hover {
    color: ${darken(0.05, colors.classicBlue)};
  }
`;

export const ExpandableContent = props => {
  const { children, closedLabel, isOpen, onClick, openLabel } = props;

  /**
   * toggles the value of showChildren(bool) and label
   */
  const handleClick = event => {
    onClick(!isOpen, event);
  };

  if (isOpen) {
    return (
      <>
        {openLabel && (
          <ExpandableContentWrapper {...props} onClick={handleClick}>
            {openLabel}
          </ExpandableContentWrapper>
        )}
        {children}
      </>
    );
  }

  return (
    <ExpandableContentWrapper {...props} onClick={handleClick}>
      {closedLabel}
    </ExpandableContentWrapper>
  );
};

ExpandableContent.defaultProps = {
  children: null,
  closedLabel: "+ Advanced Options",
  isOpen: false,
  onClick: () => {},
  openLabel: "- Basic Options"
};

ExpandableContent.propTypes = {
  /** child nodes to be rendered on click */
  children: oneOfType([arrayOf(node), node]),
  /** label to show up before content is displayed */
  closedLabel: string,
  /** defines whether the expandable content is open on load */
  isOpen: bool,
  /** function that returns the event object and open status of the component on click */
  onClick: func,
  /** label to show up after content is displayed */
  openLabel: string
};

ExpandableContentWrapper.displayName = "ExpandableContentWrapper";

export default uncontrollable(ExpandableContent, { isOpen: "onClick" });
